import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FcCheckmark } from "react-icons/fc";

import { FaLocationArrow } from "react-icons/fa6";

export const PricingContainer = styled.nav`
    color: var(--textColor);
    height: 35rem;
    display: flex;
    flex-direction: column;
    align-items: center; /* Center items horizontally */
    justify-content: center; /* Center items vertically */
    margin-bottom: 0rem;

    @media (max-width: 426px) {
      padding-top: 0rem;
    }
`

export const Heading = styled.h1`
  color: var(--textColor);
  margin-top: 2rem;
  font-weight: bold;
  font-size: var(--headingSize);

  @media (max-width: 1024px) {
      font-size: var(--smallerHeaderSize);
  }
`;

export const CardRow = styled.div`
 display: flex;
 justify-content: center;
 flex-wrap: wrap;
`;

export const Card = styled.div`
  width: 18rem;
  height: 30rem;
  margin: 1rem;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease-in-out;
  text-align: center;
  background-color: var(--card-background-color);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  outline: 1px solid rgba(255, 255, 255, 0.05);
  
  @media (max-width: 769px) {
    width: 14rem;
    height: 30rem;
    margin: 0.5rem;
  }

  @media (max-width: 426px) {
    width: calc(50% - 1rem); /* Adjust width to fit two cards per row */
    margin: 0.5rem;
  }

   &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const CardTitle = styled.h5`
  
  padding: 10px;
  font-weight: bold;
  text-align: center;
  position: relative;
  font-size: var(--subHeadingSize);

  @media (max-width: 1024px) {
    font-size: var(--smallerSubHeadingSize);
  }
`;

export const CardPrice = styled.h4`
  font-weight: bold;
  text-align: center;
  position: relative;
`

export const CardPriceSubHeading = styled.h5`
  text-align: center;
  position: relative;
  color: grey;
  margin: -0.5rem;
`

export const CardTitleBorder = styled.div`
  border-top: 2px solid #6161FF; /* Change the color and style as needed */
  margin: 0.2rem auto 20px; /* Center the line horizontally and adjust the margins as needed */
  width: 90%;
`;

export const CardBulletList = styled.ul`
  list-style-type: none;
  padding: 1.5rem;
  text-align: left;
  padding-bottom: 0.5rem;

  @media (max-width: 376px) {
    padding-bottom: 0rem;
  }

  @media (max-width: 320px) {
    padding: 0.3rem;
    padding-top: 1.5rem;
  }
`;

export const BulletListItem = styled.li`
  display: flex; /* Use flex to control the spacing between the checkmark and text */
  align-items: center; /* Center vertically */
  font-weight: normal;
  font-size: calc(var(--subHeadingSize) - 0.2rem);
  padding-bottom: 1rem;

  @media screen and (max-width: 426px) {
    font-size: calc(var(--subHeadingSize) - 0.4rem);
  }

  @media screen and (max-width: 320px) {
    font-size: calc(var(--subHeadingSize) - 0.4rem);
  }
`;

export const BulletListCheckMark = styled(FcCheckmark)`
  font-size: 1.3rem;
  margin-right: 0.5rem; /* Adjust the margin to control the space between the checkmark and text */
  
  @media (max-width: 426px) {
    font-size: 2rem;
  }
  `;

export const ArrowIcon = styled(FaLocationArrow)`
  margin-left: 0.1rem;
`;

export const CardButton = styled(Link)`
  display: inline-block;
  padding: 8px 16px;
  border-radius: 25px;
  background-color: #6161FF;
  color: white;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
  transition: background-color 0.3s;
  position: relative;

  @media screen and (max-width: 769px) {
    padding: 6px 12px;
    font-size: 12px;
  }

  &:hover {
    background-color: #3d3dcc;
    color: white;
  }
`;